// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    BUTTON_CONTAINER: 'block_button_container',
    BLOCK_BUTTON: 'block_button',
    BOTTON_LOADING: 'block_button_loading',
};
